/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_No_GamesInputs */

const th_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีการแข่งขันตามกำหนดการ`)
};

const en_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No games scheduled yet.`)
};

const ja_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定されている試合はまだありません。`)
};

const zh_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未安排比赛。`)
};

const es_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay partidos programados.`)
};

const pt_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo agendado ainda.`)
};

const id_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pertandingan yang dijadwalkan.`)
};

const fr_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun match programmé pour l’instant.`)
};

const tl_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang nakaiskedyul na laro.`)
};

const vi_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa xếp trận nào.`)
};

const ko_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 편성된 경기가 없습니다.`)
};

const de_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Spiele angesetzt.`)
};

const ru_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчи ещё не назначены.`)
};

const tr_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz maç planlanmadı.`)
};

const it_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna partita ancora in calendario.`)
};

const pl_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie zaplanowano jeszcze meczów.`)
};

const uk_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчів ще не заплановано.`)
};

const hi_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई मैच निर्धारित नहीं है।`)
};

const ar_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تُجدوَل أي مباراة بعد.`)
};

const ms_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada perlawanan dijadualkan.`)
};

const bn_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও খেলা নির্ধারিত হয়নি।`)
};

const zh_tw2_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未安排比賽。`)
};

const zh_hk2_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未安排比賽。`)
};

const ur_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی میچ طے نہیں ہوا۔`)
};

const fa_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز بازی‌ای برنامه‌ریزی نشده.`)
};

const sw_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mchezo uliopangwa bado.`)
};

const nl_event_no_games = /** @type {(inputs: Event_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen wedstrijden ingepland.`)
};

/**
* | output |
* | --- |
* | "No games scheduled yet." |
*
* @param {Event_No_GamesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_no_games = /** @type {((inputs?: Event_No_GamesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_No_GamesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_no_games(inputs)
	if (locale === "ja") return ja_event_no_games(inputs)
	if (locale === "zh") return zh_event_no_games(inputs)
	if (locale === "es") return es_event_no_games(inputs)
	if (locale === "pt") return pt_event_no_games(inputs)
	if (locale === "id") return id_event_no_games(inputs)
	if (locale === "fr") return fr_event_no_games(inputs)
	if (locale === "tl") return tl_event_no_games(inputs)
	if (locale === "vi") return vi_event_no_games(inputs)
	if (locale === "ko") return ko_event_no_games(inputs)
	if (locale === "de") return de_event_no_games(inputs)
	if (locale === "ru") return ru_event_no_games(inputs)
	if (locale === "tr") return tr_event_no_games(inputs)
	if (locale === "it") return it_event_no_games(inputs)
	if (locale === "pl") return pl_event_no_games(inputs)
	if (locale === "uk") return uk_event_no_games(inputs)
	if (locale === "hi") return hi_event_no_games(inputs)
	if (locale === "ar") return ar_event_no_games(inputs)
	if (locale === "ms") return ms_event_no_games(inputs)
	if (locale === "bn") return bn_event_no_games(inputs)
	if (locale === "zh-TW") return zh_tw2_event_no_games(inputs)
	if (locale === "zh-HK") return zh_hk2_event_no_games(inputs)
	if (locale === "ur") return ur_event_no_games(inputs)
	if (locale === "fa") return fa_event_no_games(inputs)
	if (locale === "sw") return sw_event_no_games(inputs)
	if (locale === "nl") return nl_event_no_games(inputs)
	return en_event_no_games(inputs)
});